import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHome = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 19,
	viewBox: "0 0 18 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.00012 8.79451V14.1425C1.00012 15.2626 1.00012 15.823 1.21811 16.2508C1.40986 16.6272 1.71559 16.9328 2.09192 17.1246C2.51932 17.3424 3.07912 17.3424 4.19703 17.3424H13.8032C14.9211 17.3424 15.4801 17.3424 15.9075 17.1246C16.2838 16.9328 16.5906 16.6272 16.7823 16.2508C17.0001 15.8234 17.0001 15.2639 17.0001 14.1459V8.79451C17.0001 8.26017 16.9997 7.99286 16.9347 7.74422C16.8771 7.52387 16.7826 7.31535 16.6547 7.12693C16.5104 6.9143 16.3097 6.73797 15.9075 6.38611L11.1075 2.18611C10.3609 1.53283 9.98763 1.20635 9.5675 1.08211C9.19731 0.972631 8.80273 0.972631 8.43254 1.08211C8.01273 1.20626 7.63997 1.53242 6.89448 2.18472L2.0929 6.38611C1.69076 6.73798 1.49016 6.9143 1.34583 7.12693C1.21791 7.31536 1.12267 7.52387 1.06509 7.74422C1.00012 7.99286 1.00012 8.26017 1.00012 8.79451Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgHome;
